'use client'

import Button from '@/components/Button'
import { UpRightArrowIcon } from '@/components/Icon'
import Typography from '@/components/Typography'
import AnimatedSection from '@/components/AnimatedSection'
import Automation2 from '@/public/fintech/automation_2.png'
import SecureTransactions2 from '@/public/fintech/secure_transactions_2.png'
import { default as Image, default as NextImage } from 'next/image'
import NextLink from 'next/link'
import { ReactNode } from 'react'
import styles from './styles.module.css'

interface ServiceCase {
	title: string
	description: string | ReactNode
	href?: string
	img: string
}

// fender: лютая фигня, которую надо удалить.
// т.к. Герман захерачил это всё в layout, то страница прыгает если добавить в неё ещё какую-то информацию.
// проще говоря, это костыль 🩼
const render: Record<string, ReactNode> = {
	fintech: (
		<div>
			<AnimatedSection animation="slideUp">
				<Typography variant='p1' color='subtitle'>
					Мы создаем современные и эффективные финтех-решения. В партнерстве со Сбером мы разработали систему быстрых
					и безопасных бизнес-платежей TrueCodePay. Разработка прошла все этапы тестирований, усовершенствований и
					внедрения в коммерческое использование в Сбере. Наше финтех-решение отвечает всем необходимым банковским
					стандартам России и одобрено службой безопасности банка.
				</Typography>
				<br />
				<Typography variant='p1' color='subtitle'>
					Мы готовы предложить рынку проверенные и надежные сервисы TrueCodePay.
				</Typography>
				<center>
					<Image
						src={SecureTransactions2.src}
						alt={'SecureTransactions2'}
						width={SecureTransactions2.width}
						height={SecureTransactions2.height}
						style={{
							maxHeight: 400,
							objectFit: 'contain',
							width: '100%',
							maxWidth: '100%'
						}}
					/>
				</center>
			</AnimatedSection>
			<AnimatedSection animation="slideUp">
				<Typography variant='p1' color='subtitle'>
					Финансовая отрасль обладает огромным потенциалом для автоматизации. Множество операционных задач в этой
					сфере могут быть эффективно решены с помощью современных технологий и специализированных решений. Это не
					только повысит производительность сотрудников, но и позволит оптимизировать бизнес-процессы в компании.
				</Typography>
				<center>
					<Image
						src={Automation2.src}
						alt={'SecureTransactions2'}
						width={Automation2.width}
						height={Automation2.height}
						style={{
							maxHeight: 400,
							objectFit: 'contain',
							width: '100%',
							maxWidth: '100%'
						}}
					/>
				</center>
			</AnimatedSection>
			<AnimatedSection animation="slideUp">
				<Typography variant='p1' color='subtitle'>
					TrueCodePay — сервисы для быстрых и безопасных финансовых операций в бизнесе
				</Typography>
			</AnimatedSection>
		</div>
	)
}

const serviceCases: Record<string, ServiceCase[]> = {
	development: [
		{
			title: 'Корпоративные сайты',
			description: 'Создаем функциональные корпоративные сайты, которые отражают ваш бренд',
			img: '/corporate-sites.svg'
		},
		{
			title: 'Личные кабинеты',
			description: 'Разрабатываем удобные личные кабинеты для  комфортного взаимодействие с вашими услугами',
			img: '/lk.svg'
		},
		{
			title: 'eCommerce и маркетплейсы',
			description: 'Создаем современные платформы для онлайн-торговли, которые помогают увеличить продажи',
			img: '/ecom.svg'
		},
		{
			title: 'Для государства и корпораций',
			description: 'Разрабатываем специализированные решения для государственных и корпоративных структур',
			img: '/corporations.svg'
		},
		{
			title: 'Web-приложения',
			description: 'Создаем инновационные web-приложения, которые решают конкретные задачи вашего бизнеса',
			img: '/web-app.svg'
		}
	],
	fintech: [
		{
			title: 'B2B-сервис: межкорпоративные расчёты',
			description: (
				<>
					<Typography variant='p1' color='description' className={styles.card__case__description}>
						Моментальные платежи – удобный и быстрый способ получения средств. Всего одно нажатие кнопки — и
						деньги мгновенно оказываются у получателя.
						<br />
						<br />
						«Кредит в корзине» — решение для ваших клиентов, которое помогает избежать пауз в бизнес-процессах
						из-за финансовых ограничений. Покупатель может продолжать пользоваться услугами или приобретать товары
						без задержек, связанных с недостатком средств, а ваш процесс работы с клиентом не прервется.
					</Typography>
				</>
			),
			img: '/corporate-sites.svg',
			href: '/it-solutions/b2b/'
		},
		{
			title: 'B2C-сервис: расчёт с физическими лицами',
			description:
				'Мгновенные платежи с расчетного счета компании на карту физическому лицу позволяют при расчетах обойтись без использования наличных средств. Все операции надёжно защищены, а также отражаются в бухгалтерии автоматически, это позволяет легко отслеживать перевод денег и снизить нагрузку на сотрудников, работающих “в полях”.',
			img: '/lk.svg',
			href: '/it-solutions/b2c/'
		}
	],
	['ux-ui']: [
		{
			title: 'Дизайн-сопровождение',
			description: 'Создаем и реализуем уникальные дизайн-решения для вашего проекта',
			img: '/corporate-sites.svg'
		},
		{
			title: 'Предпроектное / UX исследования',
			description: 'Изучение пользовательских потребностей для создания эффективных решений.',
			img: '/lk.svg'
		},
		{
			title: 'Аудит сайта',
			description: 'Выясняем, как оценивают сайт пользователи и поисковые системы, определяем критические ошибки.',
			img: '/ecom.svg'
		},
		{
			title: 'Проектирование интерфейсов',
			description: 'Создание интуитивно понятных и эффективных пользовательских интерфейсов.',
			img: '/corporations.svg'
		},
		{
			title: 'Nocode-сайты',
			description: 'Быстрое создание веб-сайтов без необходимости программирования.',
			img: '/no-code-site.svg'
		},
		{
			title: 'Вёрстка и интеграция дизайна',
			description: 'Превращение дизайн-макета в функциональный и интерактивный веб-сайт',
			img: '/web-app.svg'
		}
	],
	promotion: [
		{
			title: 'SEO',
			description: 'Повышение видимости вашего сайта в поисковых системах для привлечения целевого трафика',
			img: '/seo.svg'
		},
		{
			title: 'Контекстная реклама',
			description: 'Эффективное продвижение вашего бизнеса через целевые объявления в интернете',
			img: '/context-marketing.svg'
		}
	]
}

export default function ServiceCategoryContent({ params }: { params: { serviceCategory: string } }) {
	const cases = serviceCases[params.serviceCategory] ?? []
	return (
		<>
			{render[params.serviceCategory]}
			<AnimatedSection animation="slideUp">
				<div className={styles['white-block']}>
					<section className={styles.card}>
						{cases.map(({ description, href, title, img }, idx) => (
							<AnimatedSection key={title} animation="slideUp">
								<section className={styles.card__case}>
									<div className={styles.card__case__catch}>
										<Typography variant='h3'>{title}</Typography>
										{href && (
											<NextLink href={href}>
												<Button variant='outline' RightElement={UpRightArrowIcon} className={styles.button}>
													Перейти в услугу
												</Button>
											</NextLink>
										)}
									</div>
									{typeof description === 'string' ? (
										<Typography variant='p1' color='description' className={styles.card__case__description}>
											{description}
										</Typography>
									) : (
										description
									)}
									<div className={styles.card__case__img__container}>
										<NextImage
											alt={title}
											src={img}
											width={150}
											height={100}
											className={styles.card__case__img}
											sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
										/>
									</div>
								</section>
							</AnimatedSection>
						))}
					</section>
				</div>
			</AnimatedSection>
		</>
	)
}
